module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "trend",
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        本週熱門主題\n        "), _c('div', {
    staticClass: "categoryFilterDiv"
  }, [_c('el-button', {
    class: _vm.categoryFilterBtnStyle,
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.categoryFilterClick()
      }
    }
  }, [_vm._v("\n             " + _vm._s(_vm.categoryFilterLabel) + "\n             "), _c('i', {
    staticClass: "el-icon-circle-check el-icon--right"
  })]), _vm._v(" "), _c('el-card', {
    staticClass: "categoryFilterCard",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "categoryFilterElement"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-button', {
    staticClass: "applyBtn",
    on: {
      "click": function($event) {
        return _vm.categoryFilterApply()
      }
    }
  }, [_vm._v("套用")]), _vm._v(" "), _c('el-button', {
    staticClass: "cancelBtn",
    on: {
      "click": function($event) {
        return _vm.categoryFilterCancel()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.categoryFilterDefault()
      }
    }
  }, [_vm._v("恢復預設值")])], 1), _vm._v(" "), _c('div', [_c('el-checkbox-group', {
    model: {
      value: (_vm.categoryFilterList),
      callback: function($$v) {
        _vm.categoryFilterList = $$v
      },
      expression: "categoryFilterList"
    }
  }, _vm._l((_vm.categoryGroupList), function(categoryGroup) {
    return _c('div', {
      key: categoryGroup.id,
      staticClass: "category-filter-group"
    }, [_c('div', {
      staticClass: "category-filter-group-title"
    }, [_vm._v("\n                    " + _vm._s(categoryGroup.name) + "\n                  ")]), _vm._v(" "), _vm._l((categoryGroup.category), function(category) {
      return _c('div', {
        key: category.id
      }, [_c('el-checkbox', {
        attrs: {
          "label": category.id
        }
      }, [_vm._v("\n                      " + _vm._s(category.title) + "\n                    ")])], 1)
    })], 2)
  }), 0)], 1)])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.weekListLoading),
      expression: "weekListLoading"
    }],
    staticClass: "swiperContainer"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.preWeekBtnVisible),
      expression: "preWeekBtnVisible"
    }],
    staticClass: "swiperbtn preBtn el-icon-arrow-left",
    on: {
      "click": function($event) {
        return _vm.prev('week')
      }
    }
  }), _vm._v(" "), _c('swiper', {
    ref: "weekSwiper",
    staticClass: "swiper swiperStyle swiper-no-swiping",
    attrs: {
      "options": _vm.swiperOption,
      "auto-update": false
    }
  }, _vm._l((_vm.weekResources), function(obj) {
    return _c('swiper-slide', {
      key: obj.id,
      staticClass: "swiperSlide"
    }, [_c('div', {
      staticClass: "swiperDiv",
      on: {
        "click": function($event) {
          return _vm.clickSwiper(obj.id)
        }
      }
    }, [_c('div', {
      staticClass: "resouceTitle"
    }, [_vm._v(_vm._s(obj.title))]), _vm._v("\n                " + _vm._s(obj.authorName) + " "), (obj.authorName && obj.authorName != '') ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" " + _vm._s(obj.authorDep) + " "), _c('br'), _vm._v(" "), _c('StarRating', {
      staticStyle: {
        "float": "left"
      },
      attrs: {
        "rating": obj.ratingAverage,
        "show-rating": false,
        "max-rating": 5,
        "increment": 0.1,
        "star-size": 14,
        "read-only": true
      }
    }), _vm._v(" \n                " + _vm._s(obj.ratingAverage) + "  (" + _vm._s(obj.ratingCount) + ") "), _c('br'), _vm._v("\n                " + _vm._s(_vm.formatTime(obj.mtime)) + "更新 ‧ " + _vm._s(obj.viewCount) + "次觀看 "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "resouceCategory"
    }, [_vm._v(_vm._s(obj.category))]), _vm._v(" "), (obj.course_type === 1) ? _c('div', {
      staticClass: "resouceCompulsory"
    }, [_vm._v("必修")]) : _vm._e(), _vm._v(" "), (obj.course_type === 0) ? _c('div', {
      staticClass: "resouceElective"
    }, [_vm._v("選修")]) : _vm._e()], 1)])
  }), 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nextWeekBtnVisible),
      expression: "nextWeekBtnVisible"
    }],
    staticClass: "swiperbtn nextBtn el-icon-arrow-right",
    on: {
      "click": function($event) {
        return _vm.next('week')
      }
    }
  }), _vm._v(" "), (_vm.weekNoData) ? _c('div', {
    staticClass: "noDataDiv"
  }, [_vm._v("\n          抱歉，您選取的類別中找不到主題\n          "), _c('div', {
    staticClass: "noDataSubDiv"
  }, [_vm._v("\n            請嘗試選取更多類別\n          ")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        歷史熱門主題\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.settingListLoading),
      expression: "settingListLoading"
    }],
    staticClass: "swiperContainer"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.preSettingBtnVisible),
      expression: "preSettingBtnVisible"
    }],
    staticClass: "swiperbtn preBtn el-icon-arrow-left",
    on: {
      "click": function($event) {
        return _vm.prev('setting')
      }
    }
  }), _vm._v(" "), _c('swiper', {
    ref: "settingSwiper",
    staticClass: "swiper swiperStyle swiper-no-swiping",
    attrs: {
      "options": _vm.swiperOption,
      "auto-update": false
    }
  }, _vm._l((_vm.settingResources), function(obj) {
    return _c('swiper-slide', {
      key: obj.id,
      staticClass: "swiperSlide"
    }, [_c('div', {
      staticClass: "swiperDiv",
      on: {
        "click": function($event) {
          return _vm.clickSwiper(obj.id)
        }
      }
    }, [_c('div', {
      staticClass: "resouceTitle"
    }, [_vm._v(_vm._s(obj.title))]), _vm._v("\n                " + _vm._s(obj.authorName) + " "), (obj.authorName && obj.authorName != '') ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" " + _vm._s(obj.authorDep) + " "), _c('br'), _vm._v(" "), _c('StarRating', {
      staticStyle: {
        "float": "left"
      },
      attrs: {
        "rating": obj.ratingAverage,
        "show-rating": false,
        "max-rating": 5,
        "increment": 0.1,
        "star-size": 14,
        "read-only": true
      }
    }), _vm._v(" \n                " + _vm._s(obj.ratingAverage) + "  (" + _vm._s(obj.ratingCount) + ") "), _c('br'), _vm._v("\n                " + _vm._s(_vm.formatTime(obj.mtime)) + "更新 ‧ " + _vm._s(obj.viewCount) + "次觀看 "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "resouceCategory"
    }, [_vm._v(_vm._s(obj.category))]), _vm._v(" "), (obj.course_type === 1) ? _c('div', {
      staticClass: "resouceCompulsory"
    }, [_vm._v("必修")]) : _vm._e(), _vm._v(" "), (obj.course_type === 0) ? _c('div', {
      staticClass: "resouceElective"
    }, [_vm._v("選修")]) : _vm._e()], 1)])
  }), 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nextSettingBtnVisible),
      expression: "nextSettingBtnVisible"
    }],
    staticClass: "swiperbtn nextBtn el-icon-arrow-right",
    on: {
      "click": function($event) {
        return _vm.next('setting')
      }
    }
  }), _vm._v(" "), (_vm.settingNoData) ? _c('div', {
    staticClass: "noDataDiv"
  }, [_vm._v("\n          抱歉，您選取的類別中找不到主題\n          "), _c('div', {
    staticClass: "noDataSubDiv"
  }, [_vm._v("\n            請嘗試選取更多類別\n          ")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        累積最熱門主題\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.allListLoading),
      expression: "allListLoading"
    }],
    staticClass: "swiperContainer"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.preAllBtnVisible),
      expression: "preAllBtnVisible"
    }],
    staticClass: "swiperbtn preBtn el-icon-arrow-left",
    on: {
      "click": function($event) {
        return _vm.prev('all')
      }
    }
  }), _vm._v(" "), _c('swiper', {
    ref: "allSwiper",
    staticClass: "swiper swiperStyle  swiper-no-swiping",
    attrs: {
      "options": _vm.swiperOption,
      "auto-update": false
    }
  }, _vm._l((_vm.allResources), function(obj) {
    return _c('swiper-slide', {
      key: obj.id,
      staticClass: "swiperSlide"
    }, [_c('div', {
      staticClass: "swiperDiv",
      on: {
        "click": function($event) {
          return _vm.clickSwiper(obj.id)
        }
      }
    }, [_c('div', {
      staticClass: "resouceTitle"
    }, [_vm._v(_vm._s(obj.title))]), _vm._v("\n                " + _vm._s(obj.authorName) + " "), (obj.authorName && obj.authorName != '') ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" " + _vm._s(obj.authorDep) + " "), _c('br'), _vm._v(" "), _c('StarRating', {
      staticStyle: {
        "float": "left"
      },
      attrs: {
        "rating": obj.ratingAverage,
        "show-rating": false,
        "max-rating": 5,
        "increment": 0.1,
        "star-size": 14,
        "read-only": true
      }
    }), _vm._v(" \n                " + _vm._s(obj.ratingAverage) + "  (" + _vm._s(obj.ratingCount) + ") "), _c('br'), _vm._v("\n                " + _vm._s(_vm.formatTime(obj.mtime)) + "更新 ‧ " + _vm._s(obj.viewCount) + "次觀看 "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "resouceCategory"
    }, [_vm._v(_vm._s(obj.category))]), _vm._v(" "), (obj.course_type === 1) ? _c('div', {
      staticClass: "resouceCompulsory"
    }, [_vm._v("必修")]) : _vm._e(), _vm._v(" "), (obj.course_type === 0) ? _c('div', {
      staticClass: "resouceElective"
    }, [_vm._v("選修")]) : _vm._e()], 1)])
  }), 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nextAllBtnVisible),
      expression: "nextAllBtnVisible"
    }],
    staticClass: "swiperbtn nextBtn el-icon-arrow-right",
    on: {
      "click": function($event) {
        return _vm.next('all')
      }
    }
  }), _vm._v(" "), (_vm.allNoData) ? _c('div', {
    staticClass: "noDataDiv"
  }, [_vm._v("\n          抱歉，您選取的類別中找不到主題\n          "), _c('div', {
    staticClass: "noDataSubDiv"
  }, [_vm._v("\n            請嘗試選取更多類別\n          ")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n        熱門作者\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.authorsLoading),
      expression: "authorsLoading"
    }],
    staticClass: "authorContainer"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.preAuthorsBtnVisible),
      expression: "preAuthorsBtnVisible"
    }],
    staticClass: "swiperbtn preBtn el-icon-arrow-left",
    on: {
      "click": function($event) {
        return _vm.prev('author')
      }
    }
  }), _vm._v(" "), _c('swiper', {
    ref: "authorSwiper",
    staticClass: "swiper swiperStyle swiper-no-swiping",
    attrs: {
      "options": _vm.swiperOptionAuthor,
      "auto-update": false
    }
  }, _vm._l((_vm.allAuthors), function(obj) {
    return _c('swiper-slide', {
      key: obj.name,
      staticClass: "swiperSlide"
    }, [_c('div', {
      staticClass: "swiperDiv",
      on: {
        "click": function($event) {
          return _vm.clickAuthor(obj.name, obj.user.displayname)
        }
      }
    }, [_vm._v("\n              " + _vm._s(obj.user.displayname) + " \n              "), _c('div', {
      staticClass: "swiperDepDiv"
    }, [_vm._v(" \n                " + _vm._s(obj.actual_dep ? obj.actual_dep.name : obj.dep.title) + " \n              ")])])])
  }), 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nextAuthorsBtnVisible),
      expression: "nextAuthorsBtnVisible"
    }],
    staticClass: "swiperbtn nextBtn el-icon-arrow-right",
    on: {
      "click": function($event) {
        return _vm.next('author')
      }
    }
  }), _vm._v(" "), (_vm.authorsNoData) ? _c('div', {
    staticClass: "noDataDiv"
  }, [_vm._v("\n          抱歉，您選取的類別中找不到作者\n          "), _c('div', {
    staticClass: "noDataSubDiv"
  }, [_vm._v("\n            請嘗試選取更多類別\n          ")])]) : _vm._e()], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('hint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hint.display && this.$store.state.hintStatus.setting),
      expression: "hint.display && this.$store.state.hintStatus.setting"
    }],
    attrs: {
      "message": _vm.hint.message
    },
    on: {
      "close": _vm.closeHint
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-561e590c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Trend.vue
// module id = 924
// module chunks = 170